export const environment = process.env.REACT_APP_ENV || 'dev';
export const url = process.env.REACT_APP_URL_FINSPHERA;
